import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class SchoolPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.schoolRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.schoolImport,
    );
    this.schoolAutocomplete = permissionChecker.match(
      Permissions.values.schoolAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.schoolCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.schoolEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.schoolDestroy,
    );
  }
}
